import { useCallback } from 'react';

import { SxProps } from '@mui/material/styles';

import Typography from '@mui/material/Typography';

import {
  OPERATOR_COLOR,
  VALUE_COLOR,
  GROUPING_OPERATOR_COLOR,
  FIELD_COLOR,
  LOGICAL_OPERATOR_COLOR,
} from '../constants';
import {
  ChipElement,
  DefaultElement,
  GroupingOperatorElement,
  LogicalOperatorElement,
} from '../elements';

export const useRenderers = () => {
  const renderElement = useCallback((props: any) => {
    const { element } = props;

    switch (element.type) {
      case 'simple-chip': {
        return <ChipElement {...props} />;
      }
      case 'chip': {
        return <ChipElement {...props} />;
      }
      case 'logical-operator': {
        return <LogicalOperatorElement {...props} />;
      }
      case 'grouping-operator': {
        return <GroupingOperatorElement {...props} />;
      }
      default: {
        return <DefaultElement {...props} />;
      }
    }
  }, []);

  const renderLeaf = useCallback((props: any) => {
    const { attributes, children, leaf } = props;

    let style = { mt: 0.25 } as SxProps;

    if (leaf.field) {
      style = {
        ...style,
        color: FIELD_COLOR,
      };
    }

    if (leaf.value) {
      style = {
        ...style,
        color: VALUE_COLOR,
      };
    }

    if (leaf.operator) {
      style = {
        ...style,
        color: OPERATOR_COLOR,
      };
    }

    if (leaf.logicalOperator) {
      style = {
        ...style,
        color: LOGICAL_OPERATOR_COLOR,
      };
    }

    if (leaf.groupingOperator) {
      style = {
        ...style,
        color: GROUPING_OPERATOR_COLOR,
      };
    }

    return (
      <Typography component="span" variant="body2" {...attributes} sx={style}>
        {children}
      </Typography>
    );
  }, []);

  return {
    renderElement,
    renderLeaf,
  };
};
